import { object, string, number, date, InferType } from "yup";
import * as Yup from "yup";



export const formikCreateSurvey = {
  initialValues: {
    _id: null,
    title: "",
    category: "",
    createdBy:"",
    description: "",
    isActive: false

  },
  validationSchema: Yup.object({
    
    title: Yup.string().required("Required Field"),
    category: Yup.string().required("Required Field"),
    description: Yup.string().required("Required Field"),


   
  }),
};


const validationSchema = Yup.object({
  question: Yup.string().required("Question is required"),
  questionType: Yup.string().required("Please select a question type"),
  
});


export const formikAddQuestions = {
  initialValues: {
    question: "",
    questionType: "",
    options: [],
  },
  validationSchema: validationSchema,
};
